import lodash from "lodash";
import { createLoading } from "../../../../utils/loading";
import { conditionFormChecker, putField } from "../../../../utils/form";
import { toRaw, defineAsyncComponent } from "vue";

import { lessThanOrEqualTo, required, requiredWhen, validateError } from "../../../../utils/validate";
import {
    createFieldCheckbox, createFieldTemplateBuilder
} from "../../../../components/input/template-builder/template-builder.logic";
import { createConditionForm } from "./fishing-tool-declartion.condition";
import i18n from "../../../../i18n";
import { Button } from "ant-design-vue";
import { openModalForm as openModalFishingToolForm } from "../fishing-tool/fishing-tool.logic";
const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));
export const { isLoading, setIsLoading } = createLoading();

export const initForm = ({ props, data, refs }) => {
    data.fields = createFields({ props, data, refs, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
};

export const createRules = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    return {
        refFishingToolType: [required],
        refFishingTool: [required],
        qty: [
            requiredWhen({ when: () => model.refFishingTool?.isRequireInputQty }),
            {
                ...requiredWhen({
                    when: () => model.refFishingTool?.isMaximumQty,
                    requiredValidator: ({ rule, value }) => {
                        return lessThanOrEqualTo(model.refFishingTool.maximum).validator(rule, value);
                    }
                }),
                trigger: "blur"
            }
        ],
        refUnitType: [required],
        width: [
            requiredWhen({ when: () => model.refFishingTool?.isRequireInputWidth }),
            {
                ...requiredWhen({
                    when: () => model.refFishingTool?.isMaximumWidth,
                    requiredValidator: ({ rule, value }) => {
                        return lessThanOrEqualTo(model.refFishingTool.maximumWidth).validator(rule, value);
                    }
                }),
                trigger: "blur"
            }
        ],
        monthStartFishing: [required],
        monthEndFishing: [required]
    };
};

export const createFields = ({ props, data, key }) => {
    const prefix = key ? `${key}.` : "";
    const { itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    return putField({
        data, fields: [
            createFieldTemplateBuilder({
                key: `${prefix}fishingToolDeclarations`,
                cardBorderProp: () => ({
                    title: i18n.global.t("model.licenseRequest.fishingToolDeclarations"),
                    headerSize: "small",
                    paddingLeft: "0px",
                    paddingRight: "0px"
                }),
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                colProp: () => ({ xs: 24, class: "mt-4" }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        ...createFieldCheckboxFishingToolDeclaration({
                            props,
                            data,
                            isLoading,
                            itemsKey: itemsKey
                        })
                    ]})
                })
            })
        ]
    });
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};



export const createFieldCheckboxFishingToolDeclaration = ({ props, data, itemsKey, startPaddingLeft = 4 }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    data.maximumWidth = modelRef?.fishingToolRequests?.find(it => it.refFishingTool?.isMustDeclare == true).width;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const prefix = itemsKey ? `${itemsKey}.` : "";
    const fields = items
        .map((item, index) => {
            const isNotHaveChild = items.filter(child => child.refParent?.id == item.id)?.length == 0;
            const isRootAndHaveChild = !isNotHaveChild && item.refParent == null;
            if (!item.refFishingTool) {
                return null;
            }
            const level = item.refFishingTool?.level;
            let inputs = [
                createFieldCheckbox({
                    visible: () => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field: { key: `${prefix}${index}.isResult` }, items, item } }),
                    key: `${prefix}${index}.isResult`,
                    colProp: () => ({ xs: 24, md: 6 }),
                    formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                    inputProp: () => {
                        const padding = ((level || 1) - 1) * 12;
                        return lodash.merge(
                            {
                                checked: item?.isResult,
                                "onUpdate:checked": (checked) => {
                                    item.isSave = true;
                                    item.isResult = checked;
                                    if (!checked) {
                                        item.qty = null;
                                        item.width = null;
                                        item.monthStartFishing = null;
                                        item.monthEndFishing = null
                                        let childrenFishingTool = items.filter((d) => {
                                            return d.refParent?.id != null && d?.refParent?.id == item.id;
                                        });
                                        childrenFishingTool.forEach((d) => {
                                            d.isSave = true;
                                            d.isResult = false;
                                            d.qty = null;
                                            d.width = null;
                                            d.monthStartFishing = null;
                                            d.monthEndFishing = null
                                        });
                                    }
                                },
                                disabled: viewOnly,
                                text: () => `${item.refFishingTool.nameTh} ${item.refFishingTool.isSelfNamingToolName && item.fishingToolName ? item.fishingToolName : ""}`,
                                style: { paddingLeft: `${startPaddingLeft + padding}px` }
                                // class: attribute?.visibleCheck ? "" : "hidden-checkbox-only",
                            },
                            conditionFormChecker({
                                props,
                                data,
                                executeKey: "checkedProp",
                                params: { field: { key: `${prefix}${index}.isResult` }, items, item }
                            })
                        );
                    }
                }),
                {
                    visible: () => !item.isResult,
                    colProp: () => ({ xs: 0, md: 18 }),
                    formItemProp: () => ({ wrapperCol: { xs: 24, md: 24 } }),
                    inputRender: () => {
                        return ""
                    }
                },
                {
                    key: `${prefix}${index}.editButton`,
                    visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field , key: `${prefix}${index}.editButton`, items, item } }),
                    colProp: () => ({ xs: 24, md: 2 }),
                    formItemProp: () => ({  labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                    inputRender: () => {
                        return (
                            <Button
                                class="c-btn-edit btn-warning "
                                size="small"
                                onClick={() => {
                                    data.isNotShowDetail = true;
                                    openModalFishingToolForm({
                                        props: {
                                            menuContext,
                                            viewOnly,
                                            setAppPageHeader: false,
                                            form: item,
                                            itemsList: [],
                                            forceDisableEditFishingTool: true,
                                            maximumWidth: data.maximumWidth
                                        },
                                        callback: () => {
                                            data.isNotShowDetail = false;
                                        }

                                    })
                                }}
                            >
                                <CIcon file={"edit.svg"}></CIcon>
                            </Button>
                        );
                    }
                },
                {
                    visible: () => data.isNotShowDetail && item.isResult,
                    colProp: () => ({ xs: 0, md: 16 }),
                    formItemProp: () => ({ wrapperCol: { xs: 24, md: 24 } }),
                    inputRender: () => {
                        return ""
                    }
                },
                {
                    key: `${prefix}${index}.qty`,
                    visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, key: `${prefix}${index}.qty`, items, item } }),
                    colProp: () => ({ xs: 24, md: 4 }),
                    formItemProp: () => ({  labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                    label: () => !isRootAndHaveChild ? i18n.global.t("model.fishingToolRequest.qty"): "",
                    inputRender: () => {
                        return item.qty ? <div class="text-center">{item.qty + " " + item.refUnitType?.value }</div>: ""
                    }
                },
                {
                    key: `${prefix}${index}.width`,
                    visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field,  key: `${prefix}${index}.width`,  items, item  } }),
                    colProp: () => ({ xs: 24, md: 4 }),
                    formItemProp: () => ({  labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                    label: () => !isRootAndHaveChild ? i18n.global.t("model.fishingToolRequest.width2"): "",
                    inputRender: () => {
                        return item.width ? <div class="text-center">{item.width + " " + item.refWidthType?.value}</div> : ""
                    }
                },
                {
                    key: `${prefix}${index}.duringFishing`,
                    visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field,  key: `${prefix}${index}.width`,  items, item  } }),
                    colProp: () => ({ xs: 24, md: 8 }),
                    formItemProp: () => ({  labelCol: { xs: 24, md: 14 }, wrapperCol: { xs: 24, md: 10 } }),
                    label: () => !isRootAndHaveChild  ? i18n.global.t("model.fishingToolRequest.duringFishing"): "",
                    inputRender: () => {
                        return item?.monthStartFishing && item?.monthEndFishing  ? <div class="text-center">{item?.monthStartFishing + " - " + item?.monthEndFishing}</div> : ""
                    }
                }
            ]
            return inputs
        })
    return putField({
        data,
        fields: [ ...fields.flat() ]
    });
};
